module.exports = __webpack_public_path__ + "static/media/smartphones2.4983e7d2.png";